import React from 'react';
import PropTypes from 'prop-types';
import { FONT, COLOURS } from '../../constants/theme';

/**
 * BottomNav — tab bar for the venue sub-pages (Home, Story, Details…).
 *
 * Each tab item carries a key (`k`), an icon (`ic`), and a label (`lb`).
 * The active tab is highlighted; all tabs are keyboard-accessible buttons.
 *
 * @param {object}   props
 * @param {NavItem[]} props.items   - Array of tab descriptors.
 * @param {string}   props.active   - Key of the currently active tab.
 * @param {function} props.onNav    - Callback invoked with the tab key on click.
 */

/**
 * @typedef {object} NavItem
 * @property {string} k   - Unique key / route identifier.
 * @property {string} ic  - Emoji icon.
 * @property {string} lb  - Short label text.
 */

function BottomNav({ items, active, onNav }) {
  return (
    <nav
      aria-label="Section navigation"
      style={{
        background:  COLOURS.parchment,
        borderTop:   `3px solid ${COLOURS.borderGold}`,
        display:     'flex',
        justifyContent: 'space-around',
        padding:     '8px 4px',
      }}
    >
      {items.map((item) => {
        const isActive = active === item.k;
        return (
          <button
            key={item.k}
            onClick={() => onNav(item.k)}
            aria-label={item.lb}
            aria-current={isActive ? 'page' : undefined}
            style={{
              fontFamily:  FONT,
              fontSize:    6,
              cursor:      'pointer',
              padding:     '5px 6px',
              lineHeight:  1.8,
              border:      isActive ? `2px solid ${COLOURS.borderGold}` : '2px solid transparent',
              background:  isActive ? COLOURS.cream : 'transparent',
              color:       isActive ? COLOURS.primary : COLOURS.textLight,
            }}
          >
            <div style={{ fontSize: 9, marginBottom: 2 }}>{item.ic}</div>
            {item.lb}
          </button>
        );
      })}
    </nav>
  );
}

BottomNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      k:  PropTypes.string.isRequired,
      ic: PropTypes.string.isRequired,
      lb: PropTypes.string.isRequired,
    }),
  ).isRequired,
  active: PropTypes.string.isRequired,
  onNav:  PropTypes.func.isRequired,
};

export default BottomNav;
